document.addEventListener("DOMContentLoaded", function () {

  const stickyBar = document.getElementById("StickyATC");
  if (!stickyBar) return;

  /* -----------------------------
     SHOW / HIDE STICKY BAR
  ----------------------------- */

  const originalForm = document.querySelector("product-form");

  function toggleSticky() {

    /* Desktop */
    if (window.innerWidth >= 990) {

        stickyBar.classList.add("show");
        return;

    }

    /* Mobile */

    const triggerElement =
        document.querySelector(".product-form__submit") ||
        document.querySelector("product-form");

    if (!triggerElement) return;

    const rect = triggerElement.getBoundingClientRect();

    if (rect.bottom < 0) {

        stickyBar.classList.add("show");

    } else {

        stickyBar.classList.remove("show");

    }

}

  window.addEventListener("scroll", toggleSticky);
  toggleSticky();

  /* -----------------------------
     ANNOUNCEMENT SLIDER
  ----------------------------- */

  const messages = document.querySelectorAll(".sticky-message");

  if (messages.length > 1) {

    let index = 0;

    setInterval(function () {

      messages[index].classList.remove("active");

      index++;

      if (index >= messages.length) index = 0;

      messages[index].classList.add("active");

    }, 3000);

  }

  /* -----------------------------
     QUANTITY
  ----------------------------- */

  const minus = document.querySelector(".sticky-minus");
  const plus = document.querySelector(".sticky-plus");
  const qty = document.getElementById("StickyQty");

  minus.addEventListener("click", function () {

    if (Number(qty.value) > 1) {
      qty.value = Number(qty.value) - 1;
    }

  });

  plus.addEventListener("click", function () {

    qty.value = Number(qty.value) + 1;

  });

  /* -----------------------------
     ADD TO CART
  ----------------------------- */

  document.getElementById("StickySubmit").addEventListener("click", function () {

    const stickyQty = document.getElementById("StickyQty").value;

    /* Update all quantity inputs on the product form */

    document.querySelectorAll('product-form input[name="quantity"]').forEach(function(input){
        input.value = stickyQty;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    /* Update quantity selector input if present */

    document.querySelectorAll('quantity-input input').forEach(function(input){
        input.value = stickyQty;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    /* Click original Add to Cart */

    const originalButton = document.querySelector(
        'product-form button[type="submit"]'
    );

    if (originalButton) {
        originalButton.click();
    }

});

});

/* ===========================================
   STICKY PRODUCT SYNC
=========================================== */

document.addEventListener("DOMContentLoaded", function () {

    const stickyImage = document.getElementById("StickyImage");
    const stickyTitle = document.getElementById("StickyTitle");
    const stickyPrice = document.getElementById("StickyPrice");
    const stickyCompare = document.getElementById("StickyCompare");

    /* ---------------------------------------
       Get Current Variant
    --------------------------------------- */

    function updateStickyProduct() {

        const variantInput = document.querySelector('product-form input[name="id"]');

        if (!variantInput) return;

        const variantId = variantInput.value;

        if (!window.productVariants) return;

        const variant = window.productVariants.find(
            v => v.id == variantId
        );

        if (!variant) return;

        /* Image */

        if (variant.featured_image) {
    stickyImage.src = variant.featured_image.src + "&width=300";
}

        /* Title */

        if (stickyTitle) {

            stickyTitle.innerHTML = variant.name;

        }

        /* Price */

        if (stickyPrice) {

            stickyPrice.innerHTML =
                Shopify.formatMoney(
                    variant.price,
                    window.shop.money_format
                );

        }

        /* Compare Price */

        if (stickyCompare) {

            if (variant.compare_at_price > variant.price) {

                stickyCompare.style.display = "inline";

                stickyCompare.innerHTML =
                    Shopify.formatMoney(
                        variant.compare_at_price,
                        window.shop.money_format
                    );

            } else {

                stickyCompare.style.display = "none";

            }

        }

        

        /* Sold Out */

const stickyBtn = document.getElementById("StickySubmit");

if (!stickyBtn) return;

if (variant && variant.available) {

    stickyBtn.disabled = false;

    stickyBtn.innerHTML = "Add to cart";

    stickyBtn.classList.remove("sticky-sold-out");

} else {

    stickyBtn.disabled = true;

    stickyBtn.innerHTML = "Sold out";

    stickyBtn.classList.add("sticky-sold-out");

}

    }

    updateStickyProduct();

    /* Refresh after variant changes */

    document.addEventListener("change", function (e) {

        if (e.target.name === "id") {

            setTimeout(updateStickyProduct, 150);

        }

    });

});